import { useLocalStorage } from '@/hooks'
import type { TUsuarioLogado } from '@/http'
import { setLocalidade } from '@/infra/i18n'
import type { TUnidadesDeNegocioDisponiveisData } from '@/types/unidade-negocio'

export const useTrocaRegional = (user: TUsuarioLogado) => {
  const [_, setUser] = useLocalStorage<TUsuarioLogado>('user', user)
  const regionalAtual: TUnidadesDeNegocioDisponiveisData = {
    id: user.unidadeDeNegocioId,
    nome: user.unidadeDeNegocio,
    empresaId: user.empresaId,
    principal: true,
    localidade: user.localidade ?? 'pt-BR',
  }

  const handleRegionalChange = (regional?: TUnidadesDeNegocioDisponiveisData) => {
    if (!regional) return
    setLocalidade(regional.localidade)
    setUser((prev) => ({
      ...prev,
      unidadeDeNegocio: regional.nome,
      unidadeDeNegocioId: regional.id,
      empresaId: regional.empresaId,
      localidade: regional.localidade,
    }))
  }

  return { regionalAtual, handleRegionalChange }
}
